import { CHARACTER_EMOTICON_TAB } from './emoticonTypes';

export interface CharacterEmoticonItem {
  name: string;
  code: string;
}

export interface CharacterEmoticonCategory {
  id: string;
  title: string;
  categoryId: string;
  items: CharacterEmoticonItem[];
}

export const CharacterEmoticonData: CharacterEmoticonCategory[] = [
  {
    id: 'co.emoji.wedaeri',
    title: '위대리',
    categoryId: 'character_category_wedaeri',
    items: [
      { name: 'charemo_inner we_hello', code: 'we_hello' },
      { name: 'charemo_inner we_astonished', code: 'we_astonished' },
      { name: 'charemo_inner we_sorry', code: 'we_sorry' },
      { name: 'charemo_inner we_tired', code: 'we_tired' },
      { name: 'charemo_inner we_thumbs_up', code: 'we_thumbs_up' },
      { name: 'charemo_inner we_beer', code: 'we_beer' },
      { name: 'charemo_inner we_work', code: 'we_work' },
      { name: 'charemo_inner we_yesman', code: 'we_yesman' },
      { name: 'charemo_inner we_exhausted', code: 'we_exhausted' },
      { name: 'charemo_inner we_thx', code: 'we_thx' },
      { name: 'charemo_inner we_moneymoney', code: 'we_moneymoney' },
      { name: 'charemo_inner we_gift', code: 'we_gift' },
      { name: 'charemo_inner we_comfort', code: 'we_comfort' },
      { name: 'charemo_inner we_spirit', code: 'we_spirit' },
      { name: 'charemo_inner we_unamused', code: 'we_unamused' },
      { name: 'charemo_inner we_lunch', code: 'we_lunch' },
      { name: 'charemo_inner we_celebration', code: 'we_celebration' },
      { name: 'charemo_inner we_crying', code: 'we_crying' },
    ],
  },
  {
    id: 'co.emoji.gogwajang',
    title: '고과장',
    categoryId: 'character_category_gogwajang',
    items: [
      { name: 'charemo_inner go_smiling_face_with_heart', code: 'go_smiling_face_with_heart' },
      { name: 'charemo_inner go_coffee', code: 'go_coffee' },
      { name: 'charemo_inner go_celebrate', code: 'go_celebrate' },
      { name: 'charemo_inner go_support', code: 'go_support' },
      { name: 'charemo_inner go_cheer_up', code: 'go_cheer_up' },
      { name: 'charemo_inner go_retirement', code: 'go_retirement' },
      { name: 'charemo_inner go_question', code: 'go_question' },
      { name: 'charemo_inner go_birthday', code: 'go_birthday' },
      { name: 'charemo_inner go_crying', code: 'go_crying' },
      { name: 'charemo_inner go_refusal', code: 'go_refusal' },
      { name: 'charemo_inner go_sleep', code: 'go_sleep' },
      { name: 'charemo_inner go_presentation', code: 'go_presentation' },
      { name: 'charemo_inner go_overtime', code: 'go_overtime' },
      { name: 'charemo_inner go_good_moring', code: 'go_good_moring' },
      { name: 'charemo_inner go_ok', code: 'go_ok' },
      { name: 'charemo_inner go_meeting', code: 'go_meeting' },
      { name: 'charemo_inner go_passion', code: 'go_passion' },
      { name: 'charemo_inner go_tough_day', code: 'go_tough_day' },
    ],
  },
  {
    id: 'co.emoji.hasawon',
    title: '하사원',
    categoryId: 'character_category_hasawon',
    items: [
      { name: 'charemo_inner ha_say_hello', code: 'ha_say_hello' },
      { name: 'charemo_inner ha_great_job', code: 'ha_great_job' },
      { name: 'charemo_inner ha_zany', code: 'ha_zany' },
      { name: 'charemo_inner ha_congratulation', code: 'ha_congratulation' },
      { name: 'charemo_inner ha_break_time', code: 'ha_break_time' },
      { name: 'charemo_inner ha_hard_work', code: 'ha_hard_work' },
      { name: 'charemo_inner ha_pleading', code: 'ha_pleading' },
      { name: 'charemo_inner ha_hell_subway', code: 'ha_hell_subway' },
      { name: 'charemo_inner ha_appearance', code: 'ha_appearance' },
      { name: 'charemo_inner ha_screaming_in_Fear', code: 'ha_screaming_in_Fear' },
      { name: 'charemo_inner ha_shopperholic', code: 'ha_shopperholic' },
      { name: 'charemo_inner ha_exhausted', code: 'ha_exhausted' },
      { name: 'charemo_inner ha_reach_nirvana', code: 'ha_reach_nirvana' },
      { name: 'charemo_inner ha_ring_you_later', code: 'ha_ring_you_later' },
      { name: 'charemo_inner ha_mission_resolution', code: 'ha_mission_resolution' },
      { name: 'charemo_inner ha_vomiting', code: 'ha_vomiting' },
      { name: 'charemo_inner ha_corrective', code: 'ha_corrective' },
      { name: 'charemo_inner ha_gift', code: 'ha_gift' },
      { name: 'charemo_inner ha_request_confirmation', code: 'ha_request_confirmation' },
      { name: 'charemo_inner ha_fighting', code: 'ha_fighting' },
      { name: 'charemo_inner ha_transfer_complete', code: 'ha_transfer_complete' },
      { name: 'charemo_inner ha_crying_with_sweat', code: 'ha_crying_with_sweat' },
      { name: 'charemo_inner ha_moneymoney', code: 'ha_moneymoney' },
      { name: 'charemo_inner ha_power_up', code: 'ha_power_up' },
      { name: 'charemo_inner ha_announcement', code: 'ha_announcement' },
      { name: 'charemo_inner ha_acknowledged', code: 'ha_acknowledged' },
      { name: 'charemo_inner ha_overtime', code: 'ha_overtime' },
      { name: 'charemo_inner ha_good_luck', code: 'ha_good_luck' },
      { name: 'charemo_inner ha_celebrate', code: 'ha_celebrate' },
      { name: 'charemo_inner ha_working_outside', code: 'ha_working_outside' },
      { name: 'charemo_inner ha_caffeine_charging', code: 'ha_caffeine_charging' },
      { name: 'charemo_inner ha_sick', code: 'ha_sick' },
      { name: 'charemo_inner ha_crying', code: 'ha_crying' },
      { name: 'charemo_inner ha_thx', code: 'ha_thx' },
      { name: 'charemo_inner ha_star_struck', code: 'ha_star_struck' },
    ],
  },
  {
    id: 'co.emoji.dahajwi',
    title: '다하쥐',
    categoryId: 'character_category_dahagi',
    items: [
      { name: 'charemo_inner dahagi_sleep', code: 'dahagi_sleep' },
      { name: 'charemo_inner dahagi_lol', code: 'dahagi_lol' },
      { name: 'charemo_inner dahagi_angry', code: 'dahagi_angry' },
      { name: 'charemo_inner dahagi_pouting', code: 'dahagi_pouting' },
      { name: 'charemo_inner dahagi_umm', code: 'dahagi_umm' },
      { name: 'charemo_inner dahagi_peace', code: 'dahagi_peace' },
      { name: 'charemo_inner dahagi_lonely', code: 'dahagi_lonely' },
      { name: 'charemo_inner dahagi_no', code: 'dahagi_no' },
      { name: 'charemo_inner dahagi_corny', code: 'dahagi_corny' },
      { name: 'charemo_inner dahagi_pleading', code: 'dahagi_pleading' },
      { name: 'charemo_inner dahagi_do_it', code: 'dahagi_do_it' },
      { name: 'charemo_inner dahagi_full', code: 'dahagi_full' },
      { name: 'charemo_inner dahagi_good_work', code: 'dahagi_good_work' },
      { name: 'charemo_inner dahagi_heart', code: 'dahagi_heart' },
      { name: 'charemo_inner dahagi_what', code: 'dahagi_what' },
      { name: 'charemo_inner dahagi_wyd', code: 'dahagi_wyd' },
    ],
  },
  {
    id: 'co.emoji.toonka',
    title: '퉁카',
    categoryId: 'character_category_tongca',
    items: [
      { name: 'charemo_inner tongca_lululala', code: 'tongca_lululala' },
      { name: 'charemo_inner tongca_full', code: 'tongca_full' },
      { name: 'charemo_inner tongca_food', code: 'tongca_food' },
      { name: 'charemo_inner tongca_yummy', code: 'tongca_yummy' },
      { name: 'charemo_inner tongca_good', code: 'tongca_good' },
      { name: 'charemo_inner tongca_rolling', code: 'tongca_rolling' },
      { name: 'charemo_inner tongca_powerup', code: 'tongca_powerup' },
      { name: 'charemo_inner tongca_real', code: 'tongca_real' },
      { name: 'charemo_inner tongca_thx', code: 'tongca_thx' },
      { name: 'charemo_inner tongca_okay', code: 'tongca_okay' },
      { name: 'charemo_inner tongca_frowning', code: 'tongca_frowning' },
      { name: 'charemo_inner tongca_umm', code: 'tongca_umm' },
      { name: 'charemo_inner tongca_gasp', code: 'tongca_gasp' },
      { name: 'charemo_inner tongca_tired', code: 'tongca_tired' },
      { name: 'charemo_inner tongca_crying', code: 'tongca_crying' },
      { name: 'charemo_inner tongca_crying_with_sweat', code: 'tongca_crying_with_sweat' },
      { name: 'charemo_inner tongca_wyd', code: 'tongca_wyd' },
      { name: 'charemo_inner tongca_celebrate', code: 'tongca_celebrate' },
      { name: 'charemo_inner tongca_awkard', code: 'tongca_awkard' },
      { name: 'charemo_inner tongca_sleep', code: 'tongca_sleep' },
    ],
  },
  {
    id: 'co.emoji.etc',
    title: '기타',
    categoryId: 'character_category_etc',
    items: [
      { name: 'charemo_inner typo_ok', code: 'typo_ok' },
      { name: 'charemo_inner typo_bye', code: 'typo_bye' },
      { name: 'charemo_inner typo_good', code: 'typo_good' },
      { name: 'charemo_inner typo_thankyou', code: 'typo_thankyou' },
      { name: 'charemo_inner typo_sorry', code: 'typo_sorry' },
      { name: 'charemo_inner typo_no', code: 'typo_no' },
      { name: 'charemo_inner typo_call', code: 'typo_call' },
      { name: 'charemo_inner typo_sos', code: 'typo_sos' },
      { name: 'charemo_inner typo_meeting', code: 'typo_meeting' },
      { name: 'charemo_inner typo_sign', code: 'typo_sign' },
      { name: 'charemo_inner typo_coffee', code: 'typo_coffee' },
      { name: 'charemo_inner typo_cheers', code: 'typo_cheers' },
      { name: 'charemo_inner typo_congratulations', code: 'typo_congratulations' },
      { name: 'charemo_inner typo_gogo', code: 'typo_gogo' },
      { name: 'charemo_inner typo_leave', code: 'typo_leave' },
      { name: 'charemo_inner typo_vacation', code: 'typo_vacation' },
      { name: 'charemo_inner typo_foryou', code: 'typo_foryou' },
      { name: 'charemo_inner typo_christmas', code: 'typo_christmas' },
      { name: 'charemo_inner typo_fortune', code: 'typo_fortune' },
      { name: 'charemo_inner typo_newyear', code: 'typo_newyear' },
    ],
  },
];
